import currencyService from 'wanderu-service-currency';

const DEFAULT_FORMAT_OPTS = {
    style: 'currency',
};

class I18nMoney {
    constructor(value, currency = 'USD') {
        this.value = value;
        this.currency = currency;
        this.targetCurrency = I18nMoney.currency;
        this.locale = I18nMoney.locale;
    }

    static locale = 'en-us';

    static currency = 'USD';

    static setLocale(locale) {
        I18nMoney.locale = locale;
    }

    static setCurrency(currency) {
        I18nMoney.currency = currency;
    }

    static getCurrency() {
        return I18nMoney.currency;
    }

    static format(convertedPrice, opts) {
        const targetCurrency = I18nMoney.currency;
        const locale = I18nMoney.locale;

        return convertedPrice.toLocaleString(locale, {
            ...DEFAULT_FORMAT_OPTS,
            ...opts,
            currency: targetCurrency,
        });
    }

    static getConvertedPrice(value, currency) {
        const targetCurrency = I18nMoney.currency;

        return currencyService.convertPrice(
            value,
            currency,
            targetCurrency,
        );
    }

    setLocale(locale) {
        this.locale = locale;
        return this;
    }

    setCurrency(currency) {
        this.targetCurrency = currency;
        return this;
    }

    getCurrency() {
        return this.targetCurrency;
    }

    getTotalPrice() {
        const prices = this.value;
        const totalPrice = prices.reduce((total, pricingObj) => {
            let [currency, price] = Object.entries(pricingObj)[0];

            if (pricingObj.hasOwnProperty(I18nMoney.currency)) {
                currency = I18nMoney.currency;
                price = pricingObj[currency];
            }

            return total + I18nMoney.getConvertedPrice(price, currency);
        }, 0);

        return totalPrice;
    }

    getConvertedPrice() {
        const targetCurrency = this.targetCurrency || I18nMoney.currency;

        return currencyService.convertPrice(
            this.value,
            this.currency,
            targetCurrency,
        );
    }

    format(opts) {
        const targetCurrency = this.targetCurrency || I18nMoney.currency;
        const locale = this.locale || I18nMoney.locale;
        const convertedPrice = this.getConvertedPrice();

        return convertedPrice.toLocaleString(locale, {
            ...DEFAULT_FORMAT_OPTS,
            ...opts,
            currency: targetCurrency,
        });
    }
}

function i18nMoney(value, currency = 'USD') {
    return new I18nMoney(value, currency);
}

function _copyStatics(source, target) {
    Object.getOwnPropertyNames(source).forEach((property) => {
        let value;
        try {
            value = typeof source[property];
        } catch (ex) {
            // In strict mode, calling typeof on some internal properties will throw
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Strict_mode#Securing_JavaScript
            return;
        }

        if (value === 'function') {
            target[property] = source[property];
        }
    });
}

_copyStatics(I18nMoney, i18nMoney);

export { I18nMoney };
export default i18nMoney;
